module.exports = __webpack_public_path__ + "img/c5ce2bc.jpg";